module.exports = __webpack_public_path__ + "fonts/sourcesanspro-black-webfont.2c8e62e0.woff";